module.exports = __webpack_public_path__ + "img/2.bf3af5d9.jpg";